/**
 * @description JS galerie de liens
 */

(() => {
	const item = document.querySelectorAll('.list-group-item > a');

	// FUNCTION
	const galerieLinkClass = () => {
		item.forEach((el) => {
			el.classList.remove('btn', 'btn-primary');
		});
	};

	// GO 🚀
	const init = () => {
		galerieLinkClass();
	};

	init();
})();
